<template>
  <div>
    <div class="token-item-box">
      <div class="token-logo">
        <img
          v-if="img"
          :src="`/static/token/normal/${img.toLowerCase()}.svg`"
          width="30px"
          height="30px"
          class="is-vtc-al-middle"
        >
      </div>
      <div class="f-left-calc">
        <div
          class="token-code"
          data-test="token-item--token-code-div"
        >
          {{ code }}
        </div>
        <div class="token-name is-dots">
          {{ name }}
        </div>
      </div>
    </div>
    <div class="token-balance">
      {{ !balance ? 0 : balance | numberWithComma }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenItem',
  props: {
    img: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    balance: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.token-item-box {
  float: left;
  width: 100%;
  margin-top: 15px;
}
.token-logo {
  float: left;
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.token-code {
  font-weight: bold;
}
.token-name {
  font-size: 11px;
  color: #646464;
}
.token-balance {
  font-family: DINAlternate !important;
  font-weight: 500;
  padding-left: 15px;
  margin-top: 3px;
}
.f-left-calc {
  float: left;
  width: calc(100% - 30px - 5px);
}
</style>



// WEBPACK FOOTER //
// src/components/TokenItem.vue